import { formatDate } from "bos_common/src"

export const getFormattedDate = (date: Date) => {
    return formatDate(date, 'PPpp');
};

export const getFormattedNumberWithZero = (value: number) => {
    return value < 10 && value !== 0 ? `0${value}` : value;
}